// extracted by mini-css-extract-plugin
module.exports = {"button":"WodsId_button__KHQ5P"};